import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class ComplexTableStateService implements OnDestroy {
  public static VALID_EVENTS = {
    enableEdit: 'enableEdit',
    saveRow: 'saveRow',
    cancel: 'cancelEdit',
  };

  private _lockSelection = new BehaviorSubject(false);
  public lockSelection$ = this._lockSelection.asObservable();

  private _saveRow = new Subject();
  public saveRow$ = this._saveRow.asObservable();

  private _cancelEditRow = new Subject();
  public cancelEditRow$ = this._cancelEditRow.asObservable();

  private expandedElements: any[] = [];

  ngOnDestroy() {
    this._lockSelection.complete();
    this._saveRow.complete();
  }

  setExpandedElement(element) {
    this.expandedElements = [...this.expandedElements, element];
  }

  setCollapsedElement(element) {
    this.expandedElements = this.expandedElements.filter(expandedElement => expandedElement !== element);
  }

  isExpanded(element: { [key: string]: any }, byAttribute?: string) {
    const fn =
      byAttribute != null && typeof element === 'object'
        ? el => element[byAttribute] === el[byAttribute]
        : el => element === el;
    return this.expandedElements.some(fn);
  }

  clear() {
    this.expandedElements = [];
  }

  public lockSelection() {
    if (!this._lockSelection.value) {
      this._lockSelection.next(true);
    }
  }

  public unlockSelection() {
    if (this._lockSelection.value !== false) {
      this._lockSelection.next(false);
    }
  }

  triggerSaveRow(row) {
    this._saveRow.next(row);
  }

  public enableInlineEditionFor(universe: any[], selectedResouce: any) {
    const index = universe.indexOf(selectedResouce);
    if (index !== -1) {
      this.lockSelection();
      universe[index].editMode = true;
      return;
    }
    this.unlockSelection();
  }

  triggerCancelEditionRow(row) {
    this._cancelEditRow.next(row);
  }

  handleInternalEvent(elements, eventName: string, context: any[]) {
    const [firstSelection] = context;
    if (eventName === ComplexTableStateService.VALID_EVENTS.enableEdit) {
      return this.enableInlineEditionFor(elements, firstSelection);
    }
    if (eventName === ComplexTableStateService.VALID_EVENTS.saveRow) {
      return this.triggerSaveRow(firstSelection);
    }
    if (eventName === ComplexTableStateService.VALID_EVENTS.cancel) {
      return this.triggerCancelEditionRow(firstSelection);
    }
  }
}
